import actionTypes from '../constants/actionTypes/loading-action-types';

export const incrementLoadingCounter = () => ({
    type: actionTypes.INCREMENT_LOADING_COUNTER
});

export const decrementLoadingCounter = () => ({
    type: actionTypes.DECREMENT_LOADING_COUNTER
});
